// react core
import { useContext } from "react";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// entzy resources
import configEntzy from "components/config/ConfigEntzy";

// entzy context and services
import { EventContext } from "components/event/EventContext";
import ActionMessagingIdeas from "./ActionMessagingIdeas";
import ActionMessagingPost from "./ActionMessagingPost";
import ActionMessagingSelector from "./ActionMessagingSelector";

function ActionMessagingRunner(props) {
  // const user = props.user;
  const eventContext = useContext(EventContext);
  const isReplying =
    props.actionParams && props.actionParams.inReplyTo ? true : false;

  return (
    <Box className="box-default">
      <Box
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_MD,
          pl: configEntzy.APP_SPACING_MD,
          pr: configEntzy.APP_SPACING_MD,
        }}
      >
        {eventContext.state.messaging.activeRoom.startsWith("ai") && (
          <Box className="box-default">
            <ActionMessagingIdeas {...props} source="runner" />
          </Box>
        )}
        <Box className="box-default">
          {props.actionPost ? (
            <Box className="box-default">
              {eventContext.state.messaging.activeRoom === "desk" &&
              !isReplying ? (
                <Container maxWidth="xs">
                  <Typography variant="subtitle2" color="primary">
                    Customer Front Desk is Reply Only
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mt: configEntzy.APP_SPACING_MD,
                    }}
                  >
                    This room enables you to reply directly to incoming rider
                    private inquiries. When messages arrive tap underneath to
                    reply and only that rider will receive your response.
                  </Typography>
                </Container>
              ) : (
                <ActionMessagingPost {...props} source="runner" />
              )}
            </Box>
          ) : (
            <Box className="box-default">
              <ActionMessagingSelector {...props} source="runner" />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default ActionMessagingRunner;
